import { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { get } from "src/utils/networkUtils";
import useWithUrlTenant from "src/hooks/useTenant";

export default function StagePromotionDialog(props) {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedStagePeriodId, setSelectedStagePeriodId] = useState(null);
  const withTenant = useWithUrlTenant();

  useEffect(() => {
    get(withTenant(`/admin/stage-periods?offset=0&limit=200`)).then(function (response) {
      setRows(response.stagePeriods);
    });
  }, [withTenant]);

  const onCancel = () => {
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => { }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="alert-dialog-title">
        Start Stage Promotion Process
      </DialogTitle>
      <DialogContent>
        {rows === null || loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid item xs={8}>
              <FormControl fullWidth>
                <InputLabel id="week-select-label">Stage Period</InputLabel>
                <Select
                  labelId="week-select-label"
                  id="week-select"
                  value={selectedStagePeriodId}
                  label="Select Stage Period"
                  onChange={(e) => {
                    setSelectedStagePeriodId(e.target.value);
                  }}
                >
                  {rows.map((period) => (
                    <MenuItem
                      key={period.stagePeriodId}
                      value={period.stagePeriodId}
                      disabled={new Date(period.endDate) > new Date()}
                    >
                      {`${period.name} (${new Intl.DateTimeFormat("en-US", {
                        month: "short",
                      }).format(new Date(period.startDate))} ${new Date(
                        period.startDate
                      ).getDate()} - ${new Intl.DateTimeFormat("en-US", {
                        month: "short",
                      }).format(new Date(period.endDate))} ${new Date(
                        period.endDate
                      ).getDate()})`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <Button
                sx={{ height: "100%" }}
                disabled={selectedStagePeriodId === null}
                fullWidth
                variant="contained"
                onClick={() => {
                  props.onSuccessHandler(selectedStagePeriodId);
                  setLoading(true);
                }}
              >
                Start Promotion Process
              </Button>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
